import React from 'react';
import { StreamVideo, LivestreamPlayer as StreamLivestreamPlayer } from '@stream-io/video-react-sdk';
import { useStreamVideoClient } from '@feature/event-detail/hooks/useStreamVideoClient';
import './LivestreamPlayer.css';

interface Props {
  livestreamId: string;
  onError?: (error: Error) => void;
}

export function LivestreamPlayer({ livestreamId, onError }: Props): React.ReactElement {
  const { videoClient, isReady } = useStreamVideoClient();

  if (!isReady || !videoClient) {
    return (
      <div style={styles.loadingContainer}>
        <p style={styles.loadingText}>Connecting to livestream...</p>
      </div>
    );
  }

  return (
    <div style={styles.container} className="livestream-player-container">
      <StreamVideo client={videoClient}>
        <StreamLivestreamPlayer
          callType="livestream"
          callId={livestreamId}
        />
      </StreamVideo>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  },
  loadingText: {
    color: '#fff',
    fontSize: '16px',
  },
};
